/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { action, observable } from 'mobx';
import { computedFn } from 'mobx-utils';
import { LoadingItem, LoadingState } from './types';

const DEFAULT_LOADER_STATE: LoadingItem = {
  state: LoadingState.STOPPED
};

export class Loading {
  @observable _loaders: { [loaderName: string]: LoadingItem } = {};

  isLoading: (loaderName: string) => boolean = computedFn(function isLoading(loaderName: string) {
    const loaderState: LoadingState | undefined = this._loaders[loaderName]?.state;
    return loaderState === LoadingState.PENDING || loaderState === LoadingState.INITIAL || false;
  }, true);

  getLoader: (loaderName: string) => LoadingItem | undefined = computedFn(function getLoader(loaderName: string) {
    return this._loaders[loaderName];
  }, true);

  @action.bound
  registerLoader(loaderName: string, isInitial?: boolean): void {
    this.setLoader(loaderName, isInitial ? { state: LoadingState.INITIAL } : DEFAULT_LOADER_STATE);
  }

  @action.bound
  setLoader(loaderName: string, loaderState: LoadingItem): void {
    this._loaders[loaderName] = { ...loaderState };
  }

  @action.bound
  setLoaderState(loaderName: string, state: LoadingState): void {
    if (this._loaders[loaderName]) {
      this.setLoader(loaderName, { ...this._loaders[loaderName], state });
    }
  }
}
